/* eslint-disable */
import React from 'react';

const CanceledIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.33589 3.92159C4.94537 3.53106 4.3122 3.53106 3.92168 3.92159C3.53115 4.31211 3.53115 4.94528 3.92168 5.3358L8.66426 10.0784L4.07844 14.6642C3.68792 15.0547 3.68792 15.6879 4.07844 16.0784C4.46897 16.4689 5.10213 16.4689 5.49266 16.0784L10.0785 11.4926L14.5074 15.9216C14.898 16.3121 15.5311 16.3121 15.9217 15.9216C16.3122 15.531 16.3122 14.8979 15.9217 14.5074L11.4927 10.0784L16.0784 5.49265C16.4689 5.10212 16.4689 4.46896 16.0784 4.07843C15.6879 3.68791 15.0547 3.68791 14.6642 4.07843L10.0785 8.66417L5.33589 3.92159Z" fill="#727272" />
    </svg>
);

export default CanceledIcon;